module.exports = __webpack_public_path__ + "static/img/3-product-library-search-result.8a87dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-product-library-search-result.png
// module id = 1335
// module chunks = 0